import { Button } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import styles from './InlineActionToggle.module.css';

/**
 * The `+ Add …` / `− Remove …` link that reveals an optional block of configuration,
 * matching the treatment the ratio numerator and denominator cards already use.
 */
export const InlineActionToggle: React.FC<{
  isExpanded: boolean;
  onToggle: (isExpanded: boolean) => void;
  addLabel: string;
  removeLabel: string;
}> = ({ isExpanded, onToggle, addLabel, removeLabel }) => (
  <Button variant="minimal" className={styles.toggle} onPress={() => onToggle(!isExpanded)}>
    <Icon name={isExpanded ? 'minus' : 'add'} size="small" aria-hidden slot="start-icon" />
    {isExpanded ? removeLabel : addLabel}
  </Button>
);
